jQuery(function($){
	$(document).on('scfe-ajax-saving-start', function(e, data = {}) {
		console.log('Saving started', data);

		const ajaxIndicator = data.el.find('.ajax-saved');
		ajaxIndicator.find('> .ajax-saved-icon').removeClass(['fa-check', 'fa-times']).addClass(['fa-cog', 'fa-spin']);
		ajaxIndicator.find('> .ajax-saved-text').html('Saving');
	});

	$(document).on('scfe-ajax-saving-complete', function(e, data = {}) {
		console.log('Saving complete', data);

		const ajaxIndicator = data.el.find('.ajax-saved');
		ajaxIndicator.find('> .ajax-saved-icon').addClass(['fa-check', 'fa-times']).removeClass(['fa-cog', 'fa-spin']);
		ajaxIndicator.find('> .ajax-saved-text').html('Saved');
	});
});